import script from "./MSR_SO_001.vue?vue&type=script&setup=true&lang=js"
export * from "./MSR_SO_001.vue?vue&type=script&setup=true&lang=js"

import "./MSR_SO_001.vue?vue&type=style&index=0&id=79b81761&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b81761"]])

export default __exports__